module.exports = __webpack_public_path__ + "static/media/zhajinhua_m_game.2317b66.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/zhajinhua_m_game.mp4
// module id = a4fN
// module chunks = 0